import { render } from "./pluginPropVal.vue?vue&type=template&id=99884f3e&ts=true"
import script from "./pluginPropVal.vue?vue&type=script&lang=ts"
export * from "./pluginPropVal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__